import { render, staticRenderFns } from "./NewUserRegistration.vue?vue&type=template&id=3bc7f2a8&scoped=true"
import script from "./NewUserRegistration.vue?vue&type=script&lang=js"
export * from "./NewUserRegistration.vue?vue&type=script&lang=js"
import style0 from "./NewUserRegistration.vue?vue&type=style&index=0&id=3bc7f2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc7f2a8",
  null
  
)

export default component.exports